import { cn } from '@/lib/utils';
import { Icons } from './icons';

const Button = ({
  children,
  className,
  onClick,
  noPadding = false,
  noHover,
  disabled = false, // Add disabled prop
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  noPadding?: boolean;
  noHover?: boolean;
}) => (
  <button
    onClick={(e) => {
      e.stopPropagation();
      onClick?.(e);
    }}
    {...props}
    className={cn(
      'cursor-pointer rounded-md transition-all pointer-events-auto',
      disabled && 'opacity-85 cursor-not-allowed',
      noPadding ? '' : 'p-1',
      !noHover && 'hover:bg-zinc-100',
      className
    )}
  >
    {children}
  </button>
);

const IconButton = ({
  iconName = 'Like',
  classNameIcon,
  noPadding,
  noHover,
  disabled = false,

  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  iconName?: keyof typeof Icons;
  classNameIcon?: string;
  noPadding?: boolean;
  noHover?: boolean;
}) => {
  const IconComponent = !props?.children && Icons[iconName];
  return (
    <Button
      noPadding={noPadding}
      noHover={noHover}
      disabled={disabled}
      {...props}
    >
      {!props.children ? (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        <IconComponent className={cn(classNameIcon)} />
      ) : (
        <div className={cn(classNameIcon)}>{props.children}</div>
      )}
    </Button>
  );
};

export { IconButton, Button };
